import { useState } from 'react'

const initialState = {
  name: '',
  phone: '',
  email: '',
  description: '',
  website_url: '',
}

export function ContactForm() {
  const [form, setForm] = useState(initialState)
  const [status, setStatus] = useState('idle')
  const [message, setMessage] = useState('')

  function updateField(event) {
    const { name, value } = event.target
    setForm((current) => ({ ...current, [name]: value }))
  }

  async function handleSubmit(event) {
    event.preventDefault()
    setStatus('submitting')
    setMessage('')

    const payload = {
      name: form.name.trim(),
      phone: form.phone.trim(),
      email: form.email.trim(),
      description: form.description.trim(),
      website_url: form.website_url.trim(),
    }

    if (!payload.name || !payload.phone || !payload.email || !payload.description) {
      setStatus('idle')
      setMessage('Udfyld venligst alle felter.')
      return
    }

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })

      if (!response.ok) {
        throw new Error('Der opstod en fejl ved afsendelse af formularen.')
      }

      const data = await response.json()
      setStatus('success')
      setMessage(`Tak for din besked. Vi har modtaget den med id ${data.submissionId}.`)
      setForm(initialState)
    } catch (error) {
      setStatus('error')
      setMessage(error.message || 'Noget gik galt.')
    }
  }

  return (
    <form onSubmit={handleSubmit} className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
      <div className="sr-only absolute">
        <label htmlFor="website_url">Website URL</label>
        <input
          id="website_url"
          name="website_url"
          type="text"
          value={form.website_url}
          onChange={updateField}
          tabIndex={-1}
          autoComplete="off"
        />
      </div>

      <div className="grid gap-4">
        <div>
          <label htmlFor="name" className="text-sm font-medium text-slate-900">
            Navn
          </label>
          <input
            id="name"
            name="name"
            value={form.name}
            onChange={updateField}
            required
            className="mt-2 w-full rounded-2xl border border-slate-300 bg-white px-4 py-3 text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-[#3B70E5] focus:ring-4 focus:ring-[#3B70E5]/10"
            placeholder="Dit navn"
          />
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          <div>
            <label htmlFor="phone" className="text-sm font-medium text-slate-900">
              Telefonnummer
            </label>
            <input
              id="phone"
              name="phone"
              value={form.phone}
              onChange={updateField}
              required
              inputMode="tel"
              className="mt-2 w-full rounded-2xl border border-slate-300 bg-white px-4 py-3 text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-[#3B70E5] focus:ring-4 focus:ring-[#3B70E5]/10"
              placeholder="+45 12 34 56 78"
            />
          </div>
          <div>
            <label htmlFor="email" className="text-sm font-medium text-slate-900">
              Email
            </label>
            <input
              id="email"
              name="email"
              value={form.email}
              onChange={updateField}
              type="email"
              required
              className="mt-2 w-full rounded-2xl border border-slate-300 bg-white px-4 py-3 text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-[#3B70E5] focus:ring-4 focus:ring-[#3B70E5]/10"
              placeholder="navn@eksempel.dk"
            />
          </div>
        </div>

        <div>
          <label htmlFor="description" className="text-sm font-medium text-slate-900">
            Beskrivelse
          </label>
          <textarea
            id="description"
            name="description"
            value={form.description}
            onChange={updateField}
            required
            rows={6}
            className="mt-2 w-full rounded-3xl border border-slate-300 bg-white px-4 py-3 text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-[#3B70E5] focus:ring-4 focus:ring-[#3B70E5]/10"
            placeholder="Skriv din besked her"
          />
        </div>

        <button
          type="submit"
          disabled={status === 'submitting'}
          className="inline-flex items-center justify-center rounded-full bg-[#3B70E5] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#3B70E5]/90 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {status === 'submitting' ? 'Sender...' : 'Send besked'}
        </button>

        {message ? (
          <p className={status === 'error' ? 'text-sm text-red-600' : 'text-sm text-emerald-700'}>{message}</p>
        ) : null}
      </div>
    </form>
  )
}
